import { useEffect } from "react";
import { Link } from "react-scroll";
import About from "./components/About";
import Contact from "./components/Contact";
import Experience from "./components/Experience";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Portfolio from "./components/Portfolio";
import SocialLinks from "./components/SocialLinks";
import { BiChevronsUp } from "react-icons/bi";
import Shery from "sheryjs";

function App() {
  useEffect(() => {
    Shery.makeMagnet(".magnetButton", {
      ease: "cubic-bezier(0.23, 1, 0.320, 1)",
      duration: 1.5,
    });
  }, []);

  return (
    <div
      className="relative top-0"
      style={{
        background:
          "linear-gradient(to bottom, rgb(0, 0, 0) 0%, rgb(31, 41, 55) 20%, rgb(0, 0, 0) 40%, rgb(31, 41, 55) 60%, rgb(0, 0, 0) 80%, rgb(31, 41, 55) 100%)",
      }}
    >
      <div className="mx-auto max-w-screen-xl p-4 ">
        <Navbar />
        <Home />
        <Portfolio />
        <Experience />
        <About />
        <Contact />
        <SocialLinks />
      </div>
      <div className=" fixed right-10 bottom-10">
        <GoTop />
      </div>
    </div>
  );
}

export default App;

const GoTop = () => {
  return (
    <Link to="nav" className="cursor-pointer" smooth duration={500}>
      <BiChevronsUp size={50} color="white" />
    </Link>
  );
};
